<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { Globals } from "@/Globals";
import { getSiteData, goBack } from "@/NavigationHelper";
import { getKennungTitle, getKennungValueDisplay } from "@/DataHelper";
import { showSnackbar } from "@/UIHelper";
import {} from "@/CalcHelperStatic";
import { mountedBase, BaseSetup, onSave } from "@/DataLoaderStatic";
import { globalsBegriffMemo, checkBegriff } from "@/local";
import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
const validator = createEditorValidator();
provideEditorValidator(validator);
const emit = defineEmits(["back", "update:modelValue"]);
let ort = ref<string>("");
const showFahrzeug = ref<boolean>(false);
let onlyFahrzeug = ref<boolean>(false);
let selectFahrzeug = ref<boolean>(false);
let fahrtkosten = ref<boolean>(false);
let showKoordinaten = ref<boolean>(false);
let ankunftsKoordinaten = ref<string>("");
let addresseAnkunft = ref<any>();

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WEB_RK_Ortswechsel_RZ",
  backOnSave: true,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  const siteData = getSiteData();
  if (siteData.query) {
    pageParams.query = siteData.query;
  }
  const wechsel = checkBegriff("Web_RK_Fahrzeugwechsel");
  if (!siteData.ort && checkBegriff("Web_RK_Fahrzeugwechsel")) {
    showFahrzeug.value = true;
  }
  if (siteData.fahrzeug) {
    onlyFahrzeug.value = true;
    showFahrzeug.value = true;
  }
  await mountedBase(uiData, pageParams, false);
  if (uiData.data.length == 0) throw new Error("no datarow found!");
  if (!uiData.showLoading && uiData.data) {
    const row = uiData.data[0];
    const abfahrt = getKennungTitle("RK_ABFAHRTSKOORIDNATEN", uiData.columns);
    if (abfahrt) {
      showKoordinaten.value = true;
    }
    selectFahrzeug.value = getKennungValueDisplay(
      row,
      "RK_TRANSPORTMITTEL",
      uiData.columns
    );
    if (!showKoordinaten.value) {
      ort.value = getKennungValueDisplay(row, "CITY", uiData.columns);
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});

async function onValidate() {
  return await validator.validateAsync();
}
async function save() {
  const isvalid = await onValidate();
  if (!isvalid.valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        isvalid.invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  let varUebergabe: VarUebergabe[] = [];
  const siteData = getSiteData();
  if (siteData.varUbergabe) {
    varUebergabe = siteData.varUbergabe;
  }
  if (onlyFahrzeug.value && !selectFahrzeug.value) {
    let meldung = globalsBegriffMemo(
      Globals.Begriff,
      "WEB_SpeichernNichtMoeglich",
      "Speichern kann nicht durchgeführt werden da folgende Daten leer sind"
    );
    meldung = meldung + ": Fahrzeug";
    showSnackbar({
      text: meldung,
      color: "warning",
    });
    return;
  }
  if (ort.value || ankunftsKoordinaten.value) {
    await onSave(uiData, pageParams, 0, "", undefined, 0, true, varUebergabe);
  } else {
    const ortText = getKennungTitle("CITY", uiData.columns);

    let meldung = globalsBegriffMemo(
      Globals.Begriff,
      "WEB_SpeichernNichtMoeglich",
      "Speichern kann nicht durchgeführt werden da folgende Daten leer sind"
    );
    meldung = meldung + ": " + ortText;
    showSnackbar({
      text: meldung,
      color: "warning",
    });
  }
}
function checkValue(evt: any) {
  fahrtkosten = evt.value.setShow;
}
function setValueAnkunft(res: any) {
  addresseAnkunft.value = res;
}
</script>
<template>
  <v-card class="pa-0" :loading="uiData.showLoading">
    <v-card-text v-if="uiData.initialized" height="300px">
      <v-row class="py-2 pl-3">
        <span style="white-space: nowrap"
          >{{ getKennungTitle("RK_REISEBEWSTAMM", uiData.columns) }}:
        </span>

        <span class="pl-2" style="white-space: nowrap">{{
          getKennungValueDisplay(uiData.data[0], "RK_REISEBEWSTAMM", uiData.columns)
        }}</span>
      </v-row>
      <v-row v-if="!onlyFahrzeug" class="py-1 pl-3">
        <span style="white-space: nowrap"
          >{{ getKennungTitle("RK_REISEEREIGNISSE", uiData.columns) }}:
        </span>

        <span class="pl-2" style="white-space: nowrap">{{
          getKennungValueDisplay(uiData.data[0], "RK_REISEEREIGNISSE", uiData.columns)
        }}</span>
      </v-row>
      <EditComboBox
        v-if="!showKoordinaten"
        :modelValue="ort"
        @update:modelValue="ort = $event"
        kennung="CITY"
        :queryZeitbereich="pageParams.zeitbereich"
        class="pt-5"
        :clearable="true"
        :loadFavorite="true"
      />
      <EditGps
        v-if="showKoordinaten"
        :modelValue="ankunftsKoordinaten"
        @update:modelValue="ankunftsKoordinaten = $event"
        kennung="RK_ANKUNFTSKOORIDNATEN"
        :queryZeitbereich="pageParams.zeitbereich"
        :loadFavorite="true"
        :clearable="false"
        @change="setValueAnkunft"
        class="pt-5"
      />
      <v-divider color="red"></v-divider>
      <EditTextArea v-if="!onlyFahrzeug" kennung="BEMERKUNG" />

      <EditToggleSight
        v-if="showFahrzeug"
        kennung="RK_TRANSPORTMITTEL"
        :queryZeitbereich="pageParams.zeitbereich"
        v-model="selectFahrzeug"
        @seteditvalue="checkValue"
        class="pt-5"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <CommonBaseButtons
        :deleteVisible="false"
        :createVisible="false"
        :refreshVisible="false"
        :backVisible="false"
        :saveVisible="true"
        @back="goBack()"
        @save="save"
      ></CommonBaseButtons>
    </v-card-actions>
  </v-card>
</template>
